import { useState } from "react";
import { DislikeModuleProps } from "../Services/CommonServices/propTypes";
import { useLanguage } from "../Services/ContextProvider/LanguageContextProvider";

const DislikeModule = (props) => {
  const { t } = useLanguage();
  const [selectedFeedbackBtn, setSelectedFeedbackBtn] = useState("");
  const [feedbackText, setFeedbackText] = useState("");

  const handleFeedbackBtn = (btnId) => {
    setSelectedFeedbackBtn(btnId);
  };

  const handleFeedbackText = (event) => {
    const additionalfeedback = event.target.value;
    setFeedbackText(additionalfeedback);
  };

  const submitFeedback = (feedBackData) => {
    props.updateRes(feedBackData.feedBack);
    props.handleClose();
    setFeedbackText("");
  };

  const updateAppFeedback = () => {
    let feedBackData = '';
    if (selectedFeedbackBtn || (feedbackText && feedbackText.trim() !== "")) {
      if (selectedFeedbackBtn && feedbackText) {
        feedBackData = selectedFeedbackBtn + " - " + feedbackText;
      } else if (feedbackText) {
        feedBackData = t("Other Issues") + " - " + feedbackText;
      } else {
        feedBackData = selectedFeedbackBtn;
      }
      let responseStatus = {
        feedBack: feedBackData
      };
      feedBackData = responseStatus
    }
    submitFeedback(feedBackData);
  };

  const customerFeedback = [
    { id: "1", label: t("Style / Recommendation Accuracy") },
    { id: "2", label: t("Performance & Speed") },
    { id: "3", label: t("Ease of Use") },
    { id: "4", label: t("Tone & Voice") },
    { id: "5", label: t("Offensive or Unsafe Language") },
    { id: "6", label: t("Other Issues") },
  ];

  return (
    <div>
      {props.isDislikeModalOpen && (
        <div className="modal d-flex" id="myModal" role="dialog">
          <div className="modal-content feedback-content">
            <button
              name="closeButton"
              type="button"
              className="close_btn align-self-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={props.handleClose}
            >
              <img src="./static/assets/Close_icon.svg" />
            </button>
            <div className="modal-content_inner">
              <div className="modal-body">
                <div className="headline pb-3">{t("Thank You. Tell Us More")}</div>
                <div className="feedback-subtext pb-2">
                  {t("Please help us improve by providing more")} <br /> {t("details about your experience")}
                </div>
                <div className="modal-body_suggestedFeedback justify-content-center">
                  {customerFeedback.map((value, index) => (
                    <div key={"custFeedback"+index} className="inputContainer">
                      <input
                        id={"feedbackBtn-"+value.id}
                        key={"feedbackBtn-"+value.id}
                        name="feedbackBtn"
                        className={`feedbackMsg ${selectedFeedbackBtn === value.label ? "selected" : ""}`}
                        type="button"
                        value={value.label}
                        onClick={() => handleFeedbackBtn(value.label)}
                      />
                    </div>
                  ))}
                  <div className="feedback-textarea">
                    <p className="char-count">{feedbackText.length}/ 250 </p>
                    <textarea
                      className="feedback_optional_box"
                      placeholder={t("Provide additional details (optional)")}
                      value={feedbackText}
                      maxLength={250}
                      onChange={(e) => handleFeedbackText(e)}
                    />
                  </div>
                </div>

                <button
                  name="submitButton"
                  type="button"
                  id="btnStyle"
                  className="btnSize submit_btn activeBtnColor"
                  onClick={updateAppFeedback}
                >
                  {t("Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

DislikeModule.propTypes = DislikeModuleProps;

export default DislikeModule;
